import { serverInfo } from "../config/serverConfig";
import { checkResponse } from "../utils/apiError";
import { apiFetch } from "./apiFetch";

/**
 * Bulk update one or more fields across many insurance policies.
 * Body: { account_id, _ids, policy_status?, insurance_provider?, policyholder?, insured_asset?,
 *         asset_id?, vendor_id?, policy_period?, effective_date?, expiration_date?, policy_premium? }
 * Returns { matched, modified }.
 */
export async function bulkUpdateInsurances(payload) {
  const resp = await apiFetch(serverInfo.serverUrl + "/bulkUpdateInsurances", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  checkResponse(resp);
  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || "Bulk update failed");
  }
  return resp.json();
}
